export default {
  onUpdate: (registration: any) => {
    registration.unregister().then(() => {
      window.location.reload();
    });
  },
};
